import { NavItem } from '@billy/design-system'

import { VatDeclarationPeriods } from '../types/vatDeclarationPeriods'

export const getVatDeclarationPeriodItems = (vatDeclarationPeriods: VatDeclarationPeriods): NavItem[] => {
  const items: NavItem[] = []

  for (const [vatDeclarationPeriod, vatDeclarationPeriodTranslation] of Object.entries(vatDeclarationPeriods)) {
    items.push({
      id: vatDeclarationPeriod,
      children: vatDeclarationPeriodTranslation,
      value: vatDeclarationPeriod,
    })
  }

  return items
}
